import React from 'react'
import {Button, Container} from 'reactstrap'

import Layout from '../components/layout'
import FeaturedArticles from '../components/pages/index/FeaturedArticles'
import Billboard from '../components/Billboard'
import Testimonials from '../components/Testimonials'
import CustomSolutions from '../components/pages/managed/CustomSolutions'
import Expertise from '../components/pages/managed/Expertise'
import PremierPartner from '../components/pages/managed/PremierPartner'
import tablet from '../images/background/managed-solutions-billboard.svg'
import ResponsibilityChart from '../components/pages/managed-cloud-support/responsibility-chart'
import Seo from '../components/seo'
import pagerDuty from "../images/managed/pagerduty-300.png";
import pdScreen from "../images/managed/pd-screen.webp"
import newRelic from "../images/managed/new_relic_logo-350.png";
import newRelicScreen from "../images/managed/new-relic-screen.jpg"
import alertLogic from "../images/managed/alert-logic-350.png"
import alertLogicScreen from "../images/managed/alert-logic-screen.png"

const ManagedSolutionsPage = () => {
  const expertiseRef = React.createRef()

  const scroll = () => {
    expertiseRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  return (
    <Layout>
      <Seo
        title="Premier AWS Managed Service Provider"
        description="Next-gen development focused on managed DevOps, machine learning, serverless designs and micro services."
      />

      <Billboard className="Billboard--managedSolutions">
        <div className="Billboard__top">
          <h1 className="Billboard__title">aws managed solutions</h1>
          <div className="Billboard__lead">
            Supercharge your business with an AWS Premier Partner that’s ready
            for your most complex problems.
          </div>

          <div className="Billboard__cta">
            <Button className="btn-orange btn-lg" onClick={scroll}>
              Let's Get Started
            </Button>
          </div>
        </div>

        <div className="Billboard__tablet">
          <img src={tablet} alt="tablet background" />
        </div>
      </Billboard>

      <CustomSolutions />
      <ResponsibilityChart
        title={
          <>
            Shared&nbsp;
            <span className="text-dark-blue">Responsibility Model</span>
          </>
        }
        lead="Our Managed Cloud Support & Cloud Architect Manager offerings can help relieve the operational burden of cloud deployments through a shared
              responsibility model between Cloudnexa, our customer, and AWS."
      />
      <Expertise expertiseRef={expertiseRef} />
        {/* new sections start */}
        <section className="CsFeatureBlock CsFeatureBlock--white">
            <Container>
                <h2 className="Expertise__title">
                    Nextgen Monitoring&nbsp;
                    <span className="text-dark-blue">Addons</span>
                </h2>
                <div className="CsFeatureBlock__inner CsFeatureBlock__inner--reversed">
                    <div className="CsFeatureBlock__left">
                        <h2 className="CsFeatureBlock__title">
                            <img src={pagerDuty} alt="PagerDuty"/>
                        </h2>
                        <div className="CsFeatureBlock__lead">
                            Real-Time Alerting capabilities with machine data & human intelligence to improve operational visibility.
                        </div>
                    </div>

                    <div className="CsFeatureBlock__right">
                        <div className="CsFeatureBlock__img">
                            <img src={pdScreen} alt="PagerDuty" />
                        </div>
                    </div>
                </div>
            </Container>
        </section>
        <section className="CsFeatureBlock">
            <Container>
                <div className="CsFeatureBlock__inner">
                    <div className="CsFeatureBlock__left">
                        <div className="CsFeatureBlock__img">
                            <img src={newRelicScreen} alt="NewRelic" />
                        </div>
                    </div>

                    <div className="CsFeatureBlock__right">
                        <h2 className="CsFeatureBlock__title">
                            <img src={newRelic} alt="NewRelic" />
                        </h2>
                        <div className="CsFeatureBlock__lead">
                            Anomaly based end to application monitoring with predictive alerting capabilities.
                        </div>
                    </div>
                </div>
            </Container>
        </section>
        <section className="CsFeatureBlock CsFeatureBlock--white">
            <Container>
                <div className="CsFeatureBlock__inner CsFeatureBlock__inner--reversed">
                    <div className="CsFeatureBlock__left">
                        <h2 className="CsFeatureBlock__title">
                            <img src={alertLogic} alt="AlertLogic"/>
                        </h2>
                        <div className="CsFeatureBlock__lead">
                            Managed Detection and Response platform provides 24/7 protection against constantly evolving cyber attacks.
                        </div>
                    </div>

                    <div className="CsFeatureBlock__right">
                        <div className="CsFeatureBlock__img">
                            <img src={alertLogicScreen} alt="AlertLogic" />
                        </div>
                    </div>
                </div>
            </Container>
        </section>

        {/* new sections finish */}
      <PremierPartner />

      <Testimonials />
      <FeaturedArticles />
    </Layout>
  )
}

export default ManagedSolutionsPage
